export const MEETING_PURPOSES = {
  TOUR: "Tour Only",
  WORKOUT: "Workout",
};
